import React, { useCallback, useEffect, useState } from 'react';
// Aba Erros - TODOS os erros e acontecimentos do Synapse, com historico completo (Neurotech-X 23/10/2026)
// Os avisos chegam ao Manolo pelo NeuroX, em tempo real. Quadro NeuroX: trava das acoes e limite por hora.
const TK = 'synapse_token';
function hd() { return { 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem(TK) }; }
function fmt(d) { return d ? new Date(d).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' }) : '-'; }
function duracao(i) {
  const m = Math.round(((i.fim ? new Date(i.fim) : new Date()) - new Date(i.inicio)) / 60000);
  if (m < 60) return m + ' min';
  if (m < 1440) return Math.floor(m / 60) + ' h ' + (m % 60) + ' min';
  return Math.floor(m / 1440) + ' d ' + Math.floor((m % 1440) / 60) + ' h';
}
const PERIODOS = [['1', '24 horas'], ['7', '7 dias'], ['30', '30 dias'], ['90', '90 dias'], ['0', 'Tudo']];
export default function Erros() {
  const [f, setF] = useState({ estado: 'todos', codigo: '', dias: '7', q: '' });
  const [pagina, setPagina] = useState(1);
  const [dados, setDados] = useState({ total: 0, itens: [], por_pagina: 100 });
  const [codigos, setCodigos] = useState([]);
  const [aberto, setAberto] = useState(null);
  const [nx, setNx] = useState(null);
  const [nxEd, setNxEd] = useState(null);
  const [msg, setMsg] = useState('');
  const carregar = useCallback(async () => {
    try {
      const p = new URLSearchParams({ estado: f.estado, dias: f.dias, pagina: String(pagina) });
      if (f.codigo) p.set('codigo', f.codigo);
      if (f.q) p.set('q', f.q);
      const [a, b, c] = await Promise.all([fetch('/api/erros/incidentes?' + p, { headers: hd() }), fetch('/api/erros/codigos', { headers: hd() }), fetch('/api/erros/neurox', { headers: hd() })]);
      if (a.status === 401) { localStorage.removeItem(TK); window.location.href = '/login'; return; }
      if (a.ok) setDados(await a.json()); else setMsg('Erro ao carregar (' + a.status + ')');
      if (b.ok) setCodigos(await b.json());
      if (c.ok) { const j = await c.json(); setNx(j); setNxEd(e => e || { acoes_ligadas: j.acoes_ligadas, limite_hora: j.limite_hora }); }
    } catch (e) { setMsg('Erro: ' + e.message); }
  }, [f, pagina]);
  useEffect(() => { carregar(); const t = setInterval(carregar, 30000); return () => clearInterval(t); }, [carregar]);
  const filtro = (k, v) => { setPagina(1); setF({ ...f, [k]: v }); };
  const salvarNx = async () => {
    if (!nxEd) return;
    if (nx && nx.acoes_ligadas && !nxEd.acoes_ligadas && !window.confirm('Desligar TODAS as ações do NeuroX? Ele continua vendo e avisando, mas não consegue mudar nada no Synapse até você ligar de novo.')) return;
    const r = await fetch('/api/erros/neurox', { method: 'PUT', headers: hd(), body: JSON.stringify({ acoes_ligadas: nxEd.acoes_ligadas, limite_hora: Number(nxEd.limite_hora) }) });
    const j = r.ok ? null : await r.json().catch(() => ({}));
    setMsg(r.ok ? 'Quadro NeuroX salvo.' : 'Não salvou: ' + ((j && j.error) || r.status));
    setNxEd(null); carregar();
  };
  const det = (d) => {
    const o = { ...(d || {}) }; delete o.assinatura; delete o.ref;
    return Object.keys(o).map(k => k + ': ' + (typeof o[k] === 'object' ? JSON.stringify(o[k]) : String(o[k]))).join('\n');
  };
  const ocorr = (d) => (d && (d.contagem || d.ocorrencias)) || 1;
  const cel = { padding: '8px 10px', borderBottom: '1px solid rgba(255,255,255,0.08)', fontSize: 13, verticalAlign: 'top' };
  const paginas = Math.max(1, Math.ceil(dados.total / (dados.por_pagina || 100)));
  const abertos = codigos.reduce((s, c) => s + c.abertos, 0);
  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginTop: 0, marginBottom: 4 }}>Erros</h2>
      <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 18 }}>Tudo o que falha ou acontece no Synapse, com histórico completo. Os avisos chegam pelo NeuroX, em tempo real.{abertos ? <b style={{ color: '#f87171' }}> {abertos} aberto(s) agora.</b> : ' Nenhum aberto agora.'}</div>

      <div style={{ border: '1px solid rgba(255,255,255,0.12)', borderRadius: 8, padding: 14, marginBottom: 20 }}>
        <div style={{ fontWeight: 600, marginBottom: 8 }}>NeuroX</div>
        {nx && nxEd ? (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 18, alignItems: 'center' }}>
            <label style={{ display: 'flex', gap: 8, alignItems: 'center', cursor: 'pointer' }}>
              <input type="checkbox" checked={nxEd.acoes_ligadas} onChange={e => setNxEd({ ...nxEd, acoes_ligadas: e.target.checked })} />
              Ações do NeuroX {nxEd.acoes_ligadas ? <b style={{ color: '#4ade80' }}>LIGADAS</b> : <b style={{ color: '#f87171' }}>DESLIGADAS</b>}
            </label>
            <label style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
              Limite por hora
              <input type="number" min="1" max="500" value={nxEd.limite_hora} onChange={e => setNxEd({ ...nxEd, limite_hora: e.target.value })} style={{ width: 80 }} />
            </label>
            <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>Feitas: {nx.feitas_ultima_hora} na última hora, {nx.feitas_ultimo_dia} em 24 h</span>
            <button type="button" className="btn btn-primary" onClick={salvarNx}>Salvar</button>
          </div>
        ) : <span style={{ fontSize: 13 }}>carregando...</span>}
      </div>

      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'flex-end', marginBottom: 12 }}>
        <div className="form-group" style={{ margin: 0 }}><label>Situação</label>
          <select value={f.estado} onChange={e => filtro('estado', e.target.value)}><option value="todos">Todos</option><option value="abertos">Abertos</option><option value="fechados">Fechados</option></select></div>
        <div className="form-group" style={{ margin: 0 }}><label>Código</label>
          <select value={f.codigo} onChange={e => filtro('codigo', e.target.value)}><option value="">Todos</option>{codigos.map(c => <option key={c.codigo} value={c.codigo}>{c.codigo} ({c.total}{c.abertos ? ', ' + c.abertos + ' aberto(s)' : ''})</option>)}</select></div>
        <div className="form-group" style={{ margin: 0 }}><label>Período</label>
          <select value={f.dias} onChange={e => filtro('dias', e.target.value)}>{PERIODOS.map(([v, t]) => <option key={v} value={v}>{t}</option>)}</select></div>
        <div className="form-group" style={{ margin: 0 }}><label>Buscar</label>
          <input value={f.q} placeholder="texto do título" onChange={e => filtro('q', e.target.value)} /></div>
        <button type="button" className="btn" onClick={carregar}>Atualizar</button>
        <span style={{ fontSize: 13, color: 'var(--text-muted)' }}>{dados.total} registro(s) {msg && ' · ' + msg}</span>
      </div>

      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead><tr>{['Código', 'O que aconteceu', 'Agente', 'Início', 'Fim', 'Duração', 'Vezes'].map(t => <th key={t} style={{ ...cel, textAlign: 'left', color: 'var(--text-muted)' }}>{t}</th>)}</tr></thead>
        <tbody>
          {dados.itens.length === 0 && <tr><td style={cel} colSpan={7}>Nada registrado com esses filtros.</td></tr>}
          {dados.itens.map(i => (
            <React.Fragment key={i.id}>
              <tr onClick={() => setAberto(aberto === i.id ? null : i.id)} style={{ cursor: 'pointer' }}>
                <td style={cel}>{i.codigo}</td><td style={cel}>{i.titulo || '-'}</td><td style={cel}>{i.agente || '-'}</td>
                <td style={cel}>{fmt(i.inicio)}</td>
                <td style={cel}>{i.fim ? fmt(i.fim) : <b style={{ color: '#f87171' }}>ABERTO</b>}</td>
                <td style={cel}>{duracao(i)}</td><td style={cel}>{ocorr(i.detalhe)}</td>
              </tr>
              {aberto === i.id && <tr><td style={{ ...cel, background: 'rgba(255,255,255,0.03)' }} colSpan={7}><pre style={{ margin: 0, whiteSpace: 'pre-wrap', fontSize: 12 }}>{det(i.detalhe) || 'sem detalhes'}</pre></td></tr>}
            </React.Fragment>
          ))}
        </tbody>
      </table>
      {paginas > 1 && (
        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginTop: 12 }}>
          <button type="button" className="btn" disabled={pagina <= 1} onClick={() => setPagina(pagina - 1)}>Anterior</button>
          <span style={{ fontSize: 13 }}>Página {pagina} de {paginas}</span>
          <button type="button" className="btn" disabled={pagina >= paginas} onClick={() => setPagina(pagina + 1)}>Próxima</button>
        </div>
      )}
    </div>
  );
}
